(function() {
	'use strict';
	angular.module('nasracApp').factory('Dta', Dta);

	Dta.$inject = [ '$resource' ];

	function Dta($resource) {
		var resourceUrl = 'api/dta';
		var xlsxContentType = 'application/octet-stream';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getReportDates' : {
				method : 'GET',
				url : 'api/dta/reportdates',
				isArray : true
			},

			'download' : {
				method : 'GET',
				url : 'api/dta/download',
				headers : {
					accept : xlsxContentType
				},
				responseType : 'arraybuffer',
				cache : false,
				transformResponse : function(data) {
					return {
						response : new Blob([ data ], {
							type : xlsxContentType
						})
					};
				}
			},

		});
	}
})();
